import { BoardData } from '../../api/ApiTypes';
import { StatePropertyRef } from './ExtendableStore';

export type BoardInfo = BoardData;
export const BoardInfo = StatePropertyRef<BoardInfo>('board');
